import { RadioGroup } from "@headlessui/react";
import { classNames } from "../helpers";

export function PrioritySelector({
  options,
  priority,
  setPriority,
}: {
  options: { name: string; number: number }[];
  priority: { name: string; number: number };
  setPriority: (val: { name: string; number: number }) => void;
}) {
  return (
    <div>
      <RadioGroup value={priority} onChange={setPriority}>
        <RadioGroup.Label className="sr-only">Priority Level</RadioGroup.Label>
        <div className="grid grid-cols-3 gap-3 sm:grid-cols-6">
          {options.map((option) => (
            <RadioGroup.Option
              key={option.name}
              value={option}
              className={({ active, checked }) =>
                classNames(
                  active ? "ring-2 ring-offset-2 ring-indigo-500" : "",
                  checked
                    ? "bg-indigo-600 border-transparent text-white hover:bg-indigo-700"
                    : "bg-white border-gray-200 text-gray-900 hover:bg-gray-50",
                  "border rounded-md py-3 px-3 flex items-center justify-center text-sm font-medium uppercase sm:flex-1"
                )
              }
            >
              <RadioGroup.Label as="span">{option.name}</RadioGroup.Label>
            </RadioGroup.Option>
          ))}
        </div>
      </RadioGroup>
    </div>
  );
}
